import { Info } from 'lucide-react'
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover'
import { Button } from '@/components/ui/button'
import { useTranslation } from 'react-i18next'

export function OrgRoleInfoPopover() {
  const { t } = useTranslation('settings')

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button variant="ghost" size="icon" className="h-5 w-5 text-muted-foreground">
          <Info className="h-3.5 w-3.5" />
          <span className="sr-only">{t('roleInfo.srLabel')}</span>
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-80 text-sm" align="start">
        <h4 className="font-semibold text-foreground mb-3">{t('roleInfo.title')}</h4>

        <div className="space-y-3">
          <div>
            <p className="font-medium text-foreground">{t('roleInfo.ownerTitle')}</p>
            <p className="text-muted-foreground">{t('roleInfo.ownerBody')}</p>
          </div>

          <div>
            <p className="font-medium text-foreground">{t('roleInfo.adminTitle')}</p>
            <p className="text-muted-foreground">{t('roleInfo.adminBody')}</p>
          </div>

          <div>
            <p className="font-medium text-foreground">{t('roleInfo.memberTitle')}</p>
            <p className="text-muted-foreground">{t('roleInfo.memberBody')}</p>
          </div>

          <div className="border-t border-border pt-3">
            <p className="font-medium text-foreground">{t('roleInfo.guestTitle')}</p>
            <p className="text-muted-foreground">{t('roleInfo.guestBody')}</p>
          </div>
        </div>
      </PopoverContent>
    </Popover>
  )
}
